import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f067b74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "download-main-wrap"
}
const _hoisted_2 = { class: "share-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title code-title" }, "邀请二维码", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title my-invite-title" }, "我的邀请码", -1))
const _hoisted_5 = { class: "value-item" }

import { useStore } from 'vuex'
import { isApp } from '@/utils/app'
import { clearToast, debouce } from '@/utils/tools'
import { uploadFileToCrm } from '@/compositions/useUpload'
import { showToastSuccess, showToastFail } from '@/utils/tools'
import { withDefaults, ref, nextTick } from 'vue'
import wx from 'weixin-js-sdk'
import AppHost from '@/utils/app'
import html2canvas from 'html2canvas'
import Qrcode from '@chenfengyuan/vue-qrcode'


export default /*#__PURE__*/_defineComponent({
  __name: 'download-main-wrap',
  props: {
    qrcodeUrl: null,
    startDownload: { type: Boolean },
    code: { default: '' }
  },
  emits: ["download-complete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'download-complete'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { qrcodeUrl: string, startDownload: boolean, code: string };



const $store = useStore()


const mainWrap = ref()
const qrcodeOption = ref({
  width: 168,
  height: 168,
  margin: 0,
})

/**
 * 将 Blob 转换为 Base64 字符串
 */
function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const base64 = reader.result as string
      resolve(base64)
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}
/**
 * 预加载背景图片
 */
function preloadBackgroundImages(): Promise<void> {
  const imageUrls = [
    'https://static.knowledge.xag.cn/img/old-brings-new/donwload-img-bg.png',
    'https://static.knowledge.xag.cn/img/old-brings-new/download-img-info.png',
  ]
  const promises = imageUrls.map((url) => {
    return new Promise<void>((resolve, reject) => {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = () => resolve()
      img.onerror = () => reject(new Error(`Failed to load image: ${url}`))
      img.src = url
    })
  })
  return Promise.all(promises).then(() => undefined)
}

/**
 * 在浏览器中下载图片
 */
function downloadImageInBrowser(blob: Blob, filename = '邀请二维码.png') {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
async function miniProgramSaveImageHandle(blob: Blob) {
  try {
    // 将 Blob 转换为 File
    const file = new File([blob], 'invite-qrcode.jpg', { type: 'image/jpeg' })
    // 上传到 CRM 获取 URL
    const url = await uploadFileToCrm(file, false) // 二维码图片不需要压缩
    console.log('上传成功，URL:', url)
    wx.miniProgram.navigateTo({
      url: `/pages/user/save-file?url=${url}&isImg=1`,
      success: function (res) {
        console.log('跳转成功', res)
      },
      fail: function (err) {
        console.log('err', err)
        showToastFail('下载图片失败2' + err)
      },
    })
    clearToast()
    return url
  } catch (error) {
    showToastFail('下载图片失败1' + error)
  }
}
/**
 * 保存图片（根据环境调用不同方法）
 */
async function saveImage(blob: Blob) {
  try {
    if (isApp || $store?.getters?.isMiniProgram) {
      const base64 = await blobToBase64(blob)
      console.log('base64', base64.length)
      if (isApp) {
        await AppHost.saveImage(base64?.replace(/^data:image\/(png|jpg|jpeg);base64,/, ''))
        showToastSuccess('图片已保存到相册')
      } else {
        // 小程序环境：上传图片获取 URL
        await miniProgramSaveImageHandle(blob)
      }
    } else {
      // 在浏览器环境中，触发下载
      downloadImageInBrowser(blob)
      showToastSuccess('图片下载成功')
    }
    emit('download-complete')
  } catch (error) {
    console.error('保存图片失败', error)
    showToastFail('保存图片失败，请重试')
  }
}

const generateImage = debouce(async () => {
  const el = mainWrap.value
  try {
    // 预加载背景图片
    await preloadBackgroundImages()
    const canvas = await html2canvas(el, {
      useCORS: true, // 使用跨域图片
      allowTaint: false, // 不允许污染
      backgroundColor: null, // 透明背景
      scale: 2, // 提高分辨率
      logging: false, // 关闭日志
    })
    canvas.toBlob(
      (blob) => {
        if (blob) {
          saveImage(blob)
        } else {
          showToastFail('生成图片失败')
        }
      },
      'image/jpeg',
      0.8
    )
  } catch (error) {
    console.error('生成图片失败', error)
    showToastFail('生成图片失败')
  }
}, 200)

function qrcodeReadyHandle() {
  nextTick(() => {
    generateImage()
  })
}

return (_ctx: any,_cache: any) => {
  return (props.startDownload)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "main",
          id: "main",
          ref_key: "mainWrap",
          ref: mainWrap
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (props.qrcodeUrl)
              ? (_openBlock(), _createBlock(_unref(Qrcode), {
                  key: 0,
                  value: props.qrcodeUrl,
                  options: qrcodeOption.value,
                  class: "code-item",
                  onReady: qrcodeReadyHandle
                }, null, 8, ["value", "options"]))
              : _createCommentVNode("", true),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(props.code), 1)
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})